import { Group, Object3D, MeshStandardMaterial, Mesh } from 'three';

export abstract class RenderUtils {
	static clearGroup(group: Group) {
		group.traverse((object) => {
			if (RenderUtils.isMesh(object)) {
				if (object.geometry) object.geometry.dispose();

				if (object.material) {
					if (Array.isArray(object.material)) {
						object.material.forEach((material) => material.dispose());
					} else {
						object.material.dispose();
					}
				}
			}
		});

		group.clear();
	}

	static disposeObject(object: Object3D) {
		if (RenderUtils.isMesh(object)) {
			if (object.geometry) object.geometry.dispose();
			if (object.material) {
				if (Array.isArray(object.material)) {
					object.material.forEach((material) => material.dispose());
				} else {
					object.material.dispose();
				}
			}
		}

		object.traverse((child) => {
			if (RenderUtils.isMesh(child)) {
				if (child.geometry) child.geometry.dispose();
				if (child.material) {
					if (Array.isArray(child.material)) {
						child.material.forEach((material) => material.dispose());
					} else {
						child.material.dispose();
					}
				}
			}
		});
	}

	static disposeMaterial(object: Object3D) {
		if (!RenderUtils.isMesh(object)) return;

		if (Array.isArray(object.material)) {
			for (const material of object.material) {
				const mat = material as MeshStandardMaterial;

				mat.dispose();
				mat.map?.dispose();
				mat.normalMap?.dispose();
				mat.roughnessMap?.dispose();
				mat.metalnessMap?.dispose();
			}
		} else {
			const mat = object.material as MeshStandardMaterial;

			mat.dispose();
			mat.map?.dispose();
			mat.normalMap?.dispose();
			mat.roughnessMap?.dispose();
			mat.metalnessMap?.dispose();
		}
	}

	static isMesh(object: Object3D): object is Mesh {
		return object instanceof Mesh;
	}
}
